import React, { useState, useEffect, useContext } from "react";
import { UserContext } from "../../context/UserContext"; // Importa o contexto
import { useNavigate } from "react-router-dom"; // Usado para redirecionar
import axios from "axios"; // Para fazer a chamada da API
import { config } from "../../config"; // Importa a configuração com a URL da API
import styles from "./Home.module.css";
import { auth } from "../../config"; // Certifique-se de que o caminho está correto


function HomeAdm() {
  const {
    logout, // Importa a função de logout do contexto
    codigoCondominio,
    emailUsuario,
    nomeUsuario,
  } = useContext(UserContext);

  const [encomendasAtivas, setEncomendasAtivas] = useState(0); // Estado para armazenar o número de encomendas ativas
  const [clientesInativos, setClientesInativos] = useState(0); // Estado para armazenar o número de clientes inativos
  const [showConfirmLogout, setShowConfirmLogout] = useState(false); // Controle do modal de confirmação
  const navigate = useNavigate();

  // Função de logout

  const [loadingLogout, setLoadingLogout] = useState(false);

  const handleLogout = async () => {
    setLoadingLogout(true);
    try {
      await auth.signOut(); // Faz o logout no Firebase Auth
      console.log("Logout bem-sucedido no Firebase Auth.");

      logout(); // Chama a função de logout do contexto

      navigate("/"); // Redireciona para a página inicial pública
    } catch (error) {
      console.error("Erro ao fazer logout no Firebase Auth:", error);
    } finally {
      setLoadingLogout(false);
    }
  };


  // Função para buscar a quantidade de encomendas ativas
  useEffect(() => {
    if (codigoCondominio) {
      axios
        .get(`${config.apiBaseUrl}/encomendas/ativas/${codigoCondominio}`)
        .then((response) => {
          if (response.data && Array.isArray(response.data)) {
            setEncomendasAtivas(response.data.length); // Define o número de encomendas ativas no estado
          } else {
            setEncomendasAtivas(0);
          }
        })
        .catch((error) => {
          console.error("Erro ao buscar encomendas ativas:", error);
          setEncomendasAtivas(0); // Define como 0 em caso de erro
        });
    }
  }, [codigoCondominio]);

  // Função para buscar a quantidade de clientes inativos
  useEffect(() => {
    if (codigoCondominio) {
      axios
        .get(`${config.apiBaseUrl}/Cliente/listar/${codigoCondominio}`)
        .then((response) => {
          if (response.data && Array.isArray(response.data)) {
            const clientesInativos = response.data.filter(
              (cliente) => !cliente.sT_CLI
            ).length;
            setClientesInativos(clientesInativos);
          } else {
            setClientesInativos(0);
          }
        })
        .catch((error) => {
          console.error("Erro ao buscar clientes inativos:", error);
          setClientesInativos(0); // Define como 0 em caso de erro
        });
    }
  }, [codigoCondominio]);

  // Funções para controlar o modal
  const openLogoutModal = () => setShowConfirmLogout(true);
  const closeLogoutModal = () => setShowConfirmLogout(false);

  // Função para redirecionar para a página de cadastros inativos
  const handleClientesInativosClick = () => {
    navigate("/usuario/gerenciar-cadastros", {
      state: { filtroInativos: true },
    });
  };

  // Função para redirecionar para a página de Histórico com filtro de encomendas ativas
  const handleEncomendasClick = () => {
    navigate("/encomendas/historico", {
      state: { filtroAtivas: true },
    });
  };

  return (
    <section className={styles.home_container}>
      {/* Novo container com fundo para o texto de boas-vindas e os containers */}
      <div className={styles.content_container}>
        <section className={styles.welcome_text}>
          <h1>Olá, {nomeUsuario || "Usuário"}.</h1>{" "}
          {/* Substitui "Fulano" pelo nome do usuário */}
          <p>Como posso te ajudar hoje?</p>
        </section>

        <div className={styles["containers-wrapper"]}>
          <div
            className={styles.encomendasContainer}
            onClick={handleEncomendasClick}
            role="button"
            tabIndex={0}
            onKeyPress={(e) => e.key === "Enter" && handleEncomendasClick()}
          >
            <p>{encomendasAtivas} encomenda(s) ativa(s) no momento</p>
          </div>

          <div
            className={styles.clientesInativosContainer}
            onClick={handleClientesInativosClick}
            role="button"
            tabIndex={0}
            onKeyPress={(e) =>
              e.key === "Enter" && handleClientesInativosClick()
            }
          >
            <p>{clientesInativos} usuário(s) inativo(s) no momento</p>
          </div>
        </div>
      </div>

      <div className={styles.manualSection}>
        <div className={styles.manualText}>
          <p>Para acessar o manual do sistema, clique na imagem ao lado.</p>
          <p>Ele será aberto em formato PDF.</p>
        </div>
        <div className={styles.manualImage}>
          <a
            href="/manual/Manual_Gestor_GUARDAI.pdf" // Caminho do PDF
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/images/Capa_Manual_Gestor_GUARDAÍ.jpg"
              alt="Clique para abrir o manual do sistema"
              className={styles.manualThumbnail}
            />
          </a>
        </div>
      </div>


      {/* O botão de logout fica fora do novo container */}
      <button onClick={openLogoutModal} className={styles.logoutButton} disabled={loadingLogout}>
        {loadingLogout ? "Saindo..." : "Logout"}
      </button>

      {/* Modal de confirmação de logout */}
      {showConfirmLogout && (
        <div className={styles.confirmOverlay}>
          <div className={styles.confirmModal}>
            <p>Você tem certeza que deseja fazer logout?</p>
            <div className={styles.confirmModalButtons}>
              <button className={styles.confirmButton} onClick={handleLogout}>
                Sim, sair
              </button>
              <button
                className={styles.cancelButton}
                onClick={closeLogoutModal}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default HomeAdm;
